//import { useStore } from 'vuex'
//import { useI18n } from 'vue-i18n';
import store from "@/store";
import { i18n } from '@/i18n';
import { camelToSnake } from "@/common/helpers";

export function displayTypeNameOf(meter) {
  //const { t } = useI18n({ useScope: 'global' })

  //let meter_type = t(camelToSnake(meter.type));
  let meter_type = displayTypeOf(meter.type);
  if (meter.type == "WaterMeter") {
    return meter_type
  } else if (meter.type == "EnergyMeter") {
    //const store = useStore();
    console.log("Inside meter_helpers.js, displayTypeNameOf(), meter ==> ", meter);
    const energy_source = store.getters.getEnergySourceByUUID(meter.energy_source_uuid);
    console.log("Inside meter_helpers.js, displayTypeNameOf(), energy_source ==> ", energy_source);
    return meter_type + (energy_source ? " (" + energy_source.name + ")" : "");
  } else if (meter.type == "WasteMeter") {
    return meter_type
  }
}

export function displayTypeOf(meter_type) {
  //const { t } = useI18n({ useScope: 'global' });
  const { t } = i18n.global;
  return t(camelToSnake(meter_type));
}